import React from 'react';

import { getLinkCreateSuggestions } from '../../helpers/links_to_check_flow_helpers';
import { useWindowKeydown } from '../../hooks/useWindowKeydown';
import { ProductForm } from '../Products/form/ProductForm';
import { useLinksToCheckContext } from './LinksToCheckContext';

import './LinkCreate.scss';

/** The New Product form filled from the card; saving adds the product and links the page to it at once. */
const LinkCreate = () => {
  const { link, claim, closePane, answer } = useLinksToCheckContext();
  const canSave = !claim || claim.state === 'yours';

  const linkNewProduct = ({ product, userCreatedProduct, userCreatedBrand }) =>
    answer({ kind: 'link', product, metadata: { userCreatedProduct, userCreatedBrand }, sendNow: true });
  const linkExistingProduct = (productId, product) => answer({ kind: 'link', product });

  // An open select menu or the new-brand form takes Esc first
  useWindowKeydown(e => {
    if (e.key !== 'Escape' || e.defaultPrevented || document.querySelector('.product-form-new-brand-modal')) return;
    closePane();
  });

  return (
    <div className='links-to-check-create'>
      <div className='side-label'>
        <span>Add as a new product</span>
        <span>⌘↵ to add · Esc to go back</span>
      </div>
      <div className='create-product-link'>
        <span>Product link</span>
        <span title={link.url}>{link.url}</span>
      </div>
      <ProductForm
        suggestions={getLinkCreateSuggestions(link)}
        brandSuggestions={link.proposal?.brandSuggestions}
        domain={link.domain}
        saveButtonLabel='Add product'
        onSave={linkNewProduct}
        onBackClick={closePane}
        onExistingProductSelected={linkExistingProduct}
        showDescriptionFields={false}
        showMetaOptions={false}
        disabled={!canSave}
        saveOnCommandEnter
      />
    </div>
  );
};

export default LinkCreate;
